import React, { useState, useEffect, useRef } from "react";
import uparrow from "../../images/Vectoruparrow.png";
import downarrow from "../../images/Vectordownarrow.png";

const GenderDropdown = ({ selectedGender, onSelect, title }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="inputbox-margin">
        {
            title &&
            <div className="inputbox-title">{title}</div>
        }
      <div ref={dropdownRef} className="genderdropdown-container ">

        <input
          placeholder="Select Gender"
          value={selectedGender}
          onFocus={() => setShowDropdown(!showDropdown)}
          readOnly
          className="forminputbox"
        />
        <div className="up-downarrow">

          {showDropdown ? <img src={uparrow} alt="up" onClick={() => setShowDropdown(false)} /> : <img src={downarrow} alt="down" onClick={() => setShowDropdown(true)} />}
        </div>
        {showDropdown && (
          <div className="genderdropdown-options">
            {["Male", "Female", "other"].map((gender) => (
              <label
                key={gender}
                className="d-flex justify-content-between subcategory-item"
              >
                {gender === "other" ? "Prefer not to say" : gender.charAt(0).toUpperCase() + gender.slice(1)}
                <input
                  type="radio"
                  name="gender"
                  value={gender}
                  checked={selectedGender === gender}
                  onChange={() => {
                    onSelect(gender);
                    setShowDropdown(false);
                  }}
                />
              </label>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default GenderDropdown;
